import posthog from 'posthog-js';

import { SegmentProvider } from './segment';

type AnalyticsParamsOptions = Record<string, unknown>;
type AnalyticsTrackCallback = () => void;

export interface AnalyticsProvider {
  identify(userId?: string, traits?: AnalyticsParamsOptions, options?: AnalyticsParamsOptions): void;
  page(name?: string, properties?: AnalyticsParamsOptions): void;
  track(
    event: string,
    properties?: AnalyticsParamsOptions,
    options?: AnalyticsParamsOptions,
    callback?: AnalyticsTrackCallback,
  ): void;
}

const segmentProvider = new SegmentProvider();

function identify(userId?: string, traits?: AnalyticsParamsOptions, options?: AnalyticsParamsOptions): void {
  segmentProvider.identify(userId, traits, options);
  // This is necessary to track feature flag usage
  try {
    posthog.identify(userId, traits);
  } catch (error) {
    console.error('Error identifying user in PostHog', error);
  }
}

function page(name?: string, properties?: AnalyticsParamsOptions): void {
  segmentProvider.page(name, properties);
}

function track(
  event: string,
  properties?: AnalyticsParamsOptions,
  options?: AnalyticsParamsOptions,
  callback?: AnalyticsTrackCallback,
): void {
  segmentProvider.track(event, properties, options, callback);
}

export const Analytics = { identify, page, track };
